import { ReactComponent as Se } from "../assets/svg/flags/1x1/se.svg";
import { ReactComponent as No } from "../assets/svg/flags/1x1/no.svg";
import { ReactComponent as Ee } from "../assets/svg/flags/1x1/ee.svg";
import { ReactComponent as Lv } from "../assets/svg/flags/1x1/lv.svg";





class Country {


	options = [
		{
			label:"Norway", 
			value:"Norway", 
			flag:"no", 
			icon: <No width={24} height={24} />,
			className: 'flag-icon'
		},
		{
			label:"Sweden", 
			value:"Sweden", 
			flag:"se", 
			icon: <Se width={24} height={24} />,
			className: 'flag-icon'
		},
		{
			label:"Estonia", 
			value:"Estonia", 
			flag:"ee", 
			icon: <Ee width={24} height={24} />,
			className: 'flag-icon'
		},
		{
			label:"Latvia", 
			value:"Latvia", 
			flag:"lv", 
			icon: <Lv width={24} height={24} />,
			className: 'flag-icon'
		},
	];
	
	constructor() {
		

	}
	get(value){
		
		const v = Array.isArray(value) ? value : [value];
		
		var res = [];
		
		v.forEach((val)=>{
			const r = this.options.find((a)=>{return a.value == val});
			if(r)
				res.push(r);
		});
		return res.length > 1 ? res : res[0];	
	}
	
	getCode(country){
		
		var idx = this.options.findIndex((a)=>{
			return a.value == country;
		})
		
		if(idx != -1)
			return this.options[idx].flag;
		
		return '';
	}
	
	
}

export default new Country();